import { Stack } from '@mui/material';
import React from 'react';

import { CheckItemProps } from './CheckItem.props';
import { StyledCheckbox } from './CheckItem.styles';
import { Typography, TypographyVariantProps } from '../../atoms/Typography';

export const CheckItem: React.FC<CheckItemProps> = ({ label = 'CheckItem', value, onChange }) => {
  return (
    <Stack direction="row" alignItems="center" padding={0} spacing={0.5}>
      <StyledCheckbox
        color="primary"
        size="small"
        checked={value}
        onChange={(evt) => onChange(evt.target.checked)}
        slotProps={{ input: { 'aria-label': label } }}
      />
      <Typography variant={TypographyVariantProps.Body2}>{label}</Typography>
    </Stack>
  );
};
